import React from 'react'
import styled from '@emotion/styled'
import { array, bool, string } from 'prop-types'
import dayjs from 'dayjs'

import { ActivityCard } from './ActivityCard'

const ActivityContainer = styled.div`
	margin-bottom: 4rem;

	${({ isLoading }) =>
		isLoading &&
		`a {
			pointer-events: none;
			opacity: .4;
		}`}
`

ActivityFeedResults.propsTypes = {
	activityResults: array,
	firstName: string,
	isLoading: bool,
}

/**
 * Displays all the Activity Cards
 *
 * @param {Array} props.activityResults :: list of results to display
 * @param {String} props.firstName :: first name of the member
 * @param {Boolean} props.isLoading :: flag to determine if results are being fetched
 */

export function ActivityFeedResults({ activityResults, firstName, isLoading }) {
	return (
		<ActivityContainer isLoading={isLoading}>
			{activityResults &&
				activityResults.map((activity, i) => {
					const {
						canonical,
						channel,
						doc_type,
						description,
						modified_at,
						published_at,
						tags,
						title,
						thumbnail,
						total_answers,
					} = activity
					const isUpdated = dayjs(modified_at).isAfter(dayjs(published_at))
					const date = isUpdated ? modified_at : published_at

					switch (doc_type) {
						case 'answer':
							return (
								<ActivityCard
									key={i}
									avatar={thumbnail?.path}
									canonical={canonical}
									description={description}
									date={date}
									isUpdated={isUpdated}
									noFollow={total_answers < 3}
									prependTitle={firstName ? `${firstName} Answered:` : ''}
									title={title.replace('Answered: ', '')}
								/>
							)
						case 'comment':
							return (
								<ActivityCard
									key={i}
									avatar={thumbnail?.path}
									canonical={canonical}
									description={description}
									date={date}
									isUpdated={isUpdated}
									prependTitle={firstName ? `${firstName} commented on:` : ''}
									title={title}
								/>
							)
						case 'question':
							return (
								<ActivityCard
									key={i}
									avatar={thumbnail?.path}
									date={date}
									canonical={canonical}
									isUpdated={isUpdated}
									label={tags[0]}
									noFollow={total_answers < 3}
									prependTitle={firstName ? `${firstName} Asked:` : ''}
									title={title}
								/>
							)

						case 'user':
							return (
								<ActivityCard
									key={i}
									avatar={thumbnail?.path}
									canonical={canonical}
									description={description}
									date={date}
									isUpdated={isUpdated}
									label={channel.name}
									title={title}
								/>
							)
						case 'business_listing':
						case 'featured_listing':
						case 'adunit':
							return null
						case 'article':
						case 'category':
						case 'review':
						default:
							return (
								<ActivityCard
									key={i}
									canonical={canonical}
									description={description}
									date={date}
									isUpdated={isUpdated}
									label={channel.name}
									title={title}
									thumbnail={thumbnail?.path}
								/>
							)
					}
				})}
		</ActivityContainer>
	)
}
